import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=4eff24fc&scoped=true"
import script from "./Reactions.vue?vue&type=script&lang=js"
export * from "./Reactions.vue?vue&type=script&lang=js"
import style0 from "./Reactions.vue?vue&type=style&index=0&id=4eff24fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff24fc",
  null
  
)

export default component.exports